import type { IconData } from '@stacksjs/iconify-core'

export const bg4x3: IconData = {
  "body": "<path fill=\"#fff\" d=\"M0 0h640v160H0z\"/><path fill=\"#00966e\" d=\"M0 160h640v160H0z\"/><path fill=\"#d62612\" d=\"M0 320h640v160H0z\"/>",
  "width": 640,
  "height": 480,
  "viewBox": "0 0 640 480"
}

export default bg4x3
